import { render, staticRenderFns } from "./AddEquipmentPage.component.html?vue&type=template&id=47f0670f&scoped=true&external"
import script from "./AddEquipmentPage.component.ts?vue&type=script&lang=ts&external"
export * from "./AddEquipmentPage.component.ts?vue&type=script&lang=ts&external"
import style0 from "./AddEquipmentPage.component.scss?vue&type=style&index=0&id=47f0670f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0670f",
  null
  
)

export default component.exports